/** Extract "uploads/..." from an absolute or relative public URL. */
export function toUploadsRelativePath(publicUrl: string): string | null {
  if (!publicUrl) return null;
  try {
    const u = new URL(publicUrl, typeof window !== 'undefined' ? window.location.origin : 'http://localhost');
    return u.pathname.startsWith('/uploads/') ? u.pathname.slice(1) : null;
  } catch {
    if (publicUrl.startsWith('/uploads/')) return publicUrl.slice(1);
    if (publicUrl.startsWith('uploads/')) return publicUrl;
    return null;
  }
}

/** Build a derivative URL with the chosen strategy. */
export function buildDerivativeUrl(
  apiBase: string,
  strategy: 'resolve' | 'cache',
  filter: string,
  uploadsRel: string
): string {
  const prefix = strategy === 'resolve' ? '/media/cache/resolve' : '/media/cache';
  return `${apiBase}${prefix}/${filter}/${uploadsRel}`;
}
